import React from 'react';
import client from '../../logic/restaurant';
import restaurantReducer, { defaultState } from '../reducers/restaurant-reducer';
import actions from '../actions/restaurant';
import dl from '../device-language';
import formats from '../formats';

const RestaurantContext = React.createContext();

function RestaurantProvider(props) {
    const [state, setState] = React.useReducer(restaurantReducer, defaultState);

    const { isLoading, restaurant, error, search } = state;

    const run = React.useCallback(async (promise, search) => {
        if (search || search == "") {
            const restaurant = await promise;
            const searchedPayload = await client.doGetSearch("it", restaurant.id, search);

            formats.setSearchedItems(restaurant, searchedPayload, search);
        }

        return promise.then(
            restaurant => setState(actions.success(restaurant)),
            error => setState(actions.error(error))
        );
    }, []);

    const setRestaurant = React.useCallback(async id => {
        setState(actions.fetching(id));
        await run(client.doGet(dl.getApiLanguage(), id));
    }, [run]);
    const setSearch = React.useCallback(async search => {
        setState(actions.searching(search));
        await run(client.doGet(dl.getApiLanguage(), restaurant.id), search);
    });

    const value = React.useMemo(() => {
        return {
            error,
            isLoading,
            restaurant,
            search,
            setRestaurant,
            setSearch,
        }
    }, [error, isLoading, restaurant, search, setRestaurant, setSearch]);

    return <RestaurantContext.Provider value={value} {...props} />;
}

function useRestaurant() {
    const context = React.useContext(RestaurantContext);
    if (!context) {
        throw new Error("useRestaurant must be used within a RestaurantProvider");
    }
    return context;
}

export { RestaurantProvider, useRestaurant }
